var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 22.4248V15.6748C25.25 10.5662 21.1086 6.4248 16 6.4248V6.4248C10.8914 6.4248 6.75 10.5662 6.75 15.6748V22.4248",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 18.6748C21 18.1225 21.4477 17.6748 22 17.6748C23.1046 17.6748 24 18.5702 24 19.6748V24.4248C24 25.6674 22.9926 26.6748 21.75 26.6748C21.3358 26.6748 21 26.339 21 25.9248V18.6748Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 19.6748C8 18.5702 8.89543 17.6748 10 17.6748C10.5523 17.6748 11 18.1225 11 18.6748V25.9248C11 26.339 10.6642 26.6748 10.25 26.6748C9.00736 26.6748 8 25.6674 8 24.4248V19.6748Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListen);
export default __webpack_public_path__ + "static/media/Listen.80341dc2b9ff12cb6bd5081650f2c17f.svg";
export { ForwardRef as ReactComponent };